<template>
	<div class="news-item-comp"
		 :id="'news_'+id"
		 @click="onClick">
		<div class="wrap info-wrap">
			<div class="title text--title">{{ title }}</div>
			<div class="info-sub-wrap text--sub">
				<span>{{
          `${nickname} · ${publish_date}`
        }}</span>
				<span>
					<img class="view-img"
						 src="../assets/images/readNum.png" />
					<span>{{ view }}</span>
				</span>
			</div>
		</div>
		<div class="wrap img-wrap">
			<img class="cover-img"
				 v-lazy="cover" />
			<span class="category">{{cate_name}}</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'newsItem',
	props: {
		id: {
			type: [String, Number]
		},
		title: {
			type: String
		},
		nickname: {
			type: String
		},
		publish_date: {
			type: String
		},
		view: {
			type: Number
		},
		cover: {
			type: String
		},
		action_id: {
			type: Number,
			default: 0
		},
		cate_name: {
			type: String,
			default: ''
		},
		is_admin_publish: {
			type: Number
		},
		beforeClick: {
			type: Function,
			default: () => { }
		},
		geneId: {
			type: Number
		},
		tabId: {
			type: Number
		}
	},
	created() {
		// console.log(this.geneId)
	},
	methods: {
		onClick() {
			if (!!this.beforeClick) {
				this.beforeClick();
			}
			if (this.geneId == 2 || this.tabId == 2) {
				this.$router.push({ name: 'digitalGeneral', query: { id: this.id }});
			} else {
				this.$router.push({ name: 'newsDetail', query: { id: this.id } });
			}
		},

		onAuthorClick() {
			this.$router.push({
				name: 'userCenter',
				query: {
					action_id: this.action_id,
					is_admin_publish: this.is_admin_publish
				}
			});
		}
	}
};
</script>

<style lang="stylus" scoped>
.news-item-comp {
	height: 230px;
	padding: 36px 15px 45px;
	border-bottom: 1PX solid #F1F1F1;
	display: flex;

	.info-wrap {
		flex: 1;
		margin-right: 40px;

		.title {
			height: 78px;
			line-height: 42px;
			margin-bottom: 50px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
		}

		.info-sub-wrap {
			display: flex;
			justify-content: space-between;

			.view-img {
				width: 31px;
				height: 21px;
				margin-right: 4px;
			}
		}
	}

	.img-wrap {
		position: relative;
		flex: 0 0 200px;
		display: flex;
		width: 200px;
		height: 150px;
		border-radius: 10px;
		border: 1PX solid #eee;
		overflow: hidden;
		.cover-img {
			width: 100%;
			height: 100%;
		}

		.category {
			display: inline-block;
			position: absolute;
			bottom: 0;
			left: 0;
			border-top-right-radius: 10px;
			// border-bottom-left-radius: 10px;
			text-align: center;
			color: #fff;
			font-size: 18px;
			width: 100px;
			height: 30px;
			line-height: 30px;
			background-color: rgba(0, 0, 0, 0.5);

			&::before {
				content: '';
				display: inline-block;
				vertical-align: middle;
				width: 0;
				height: 100%;
				margin-top: 1px;
			}
		}
	}
}
</style>
